import { QueryClient } from "@tanstack/react-query";

import { ApiError } from "@/api/errors";

/**
 * Server state fica sob o TanStack Query.
 *
 * Política de retry: erro 4xx é decisão do servidor (não autenticado, sem
 * permissão, validação, sem créditos) — insistir não muda nada e ainda pode
 * disparar rate limit. Só falhas de rede e 5xx são tentadas de novo.
 */
function shouldRetry(failureCount: number, error: unknown): boolean {
  if (failureCount >= 2) return false;

  if (error instanceof ApiError) {
    if (error.code === "network_error") return true;
    return error.status >= 500;
  }

  return false;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: shouldRetry,
        staleTime: 30_000,
        refetchOnWindowFocus: false,
      },
      mutations: {
        // Mutação que mexe em crédito NUNCA é repetida automaticamente.
        // O retry, quando existir, é explícito e reusa a Idempotency-Key.
        retry: false,
      },
    },
  });
}
